import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PopularDestinationCategoryService {

  private apiUrl = environment.apiBaseUrl + '/api/';

  constructor(private http: HttpClient) { }

  // GET roles
  getAllPopularDestinationCategories(): Observable<any> {
    return this.http.get(`${this.apiUrl}popular-destination-categories/getAll`);
  }

  getPopularDestinationCategoryById(id: number): Observable<any> {
    return this.http.get(`${this.apiUrl}popular-destination-categories/GetById/${id}`);
  }

  create(request: any): Observable<any> {
    return this.http.post(`${this.apiUrl}popular-destination-categories`, request);
  }

  update(request: any): Observable<any> {
    return this.http.put(`${this.apiUrl}popular-destination-categories`, request);
  }

  delete(id: number): Observable<any> {
    return this.http.delete(`${this.apiUrl}popular-destination-categories/${id}`);
  }
}
